import React from "react";
import "./index.scss";
import {useDispatch} from "react-redux";
import {createAction} from "../../../utils/sagaHelper";
import {CopyToClipboard} from "../CopyToClipboard/CopyToClipboard";
import ColumnTitleWithIcon from "../ColumnTitleWithIcon";

export const SectionItemCopyToClipboard = ({column, item}) => {
    const dispatch = useDispatch();

    const onClickCopy = () => {
        if(column.actionName) {
            dispatch(createAction(column.actionName, {column, item, id: item.id}))
        }
    }

    return (
        <div className={"sectionItemCopyToClipboard"}>
            <ColumnTitleWithIcon column={column} item={item}/>
            <CopyToClipboard onClick={onClickCopy} icon={column.icon} tooltip={column.tooltip || column.tooltip}/>
        </div>
    )
};